// Devise signs out on DELETE, and only a real form submit (not an Inertia
// visit) clears the session cookie and lands on the logged-out page cleanly.
export function signOut() {
  const form = document.createElement("form");
  form.method = "post";
  form.action = "/users/sign_out";
  const methodInput = document.createElement("input");
  methodInput.type = "hidden";
  methodInput.name = "_method";
  methodInput.value = "delete";
  const csrfInput = document.createElement("input");
  csrfInput.type = "hidden";
  csrfInput.name = "authenticity_token";
  csrfInput.value =
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content ?? "";
  form.append(methodInput, csrfInput);
  document.body.appendChild(form);
  form.submit();
}
